/**
 * The primary address among those of one type (KOR-15208): the first one flagged primary, or the first address when
 * none is - a type always has exactly one, and a stored customer's primary arrives flagged.
 */
export const primaryIndex = (addresses?: ({ primary?: boolean } | undefined)[]): number => {
  const flagged = (addresses ?? []).findIndex((address) => address?.primary);
  return flagged === -1 ? 0 : flagged;
};
